<div style="padding-top: 33px">
  <p class="text-default-50 heading-l nunito-regular-font lh-24 page-heading">
    Log Out
  </p>
  <div class="logout-container text-default-50 nunito-regular-font">
    <div
      class="flex flex-row items-center"
      style="line-height: 40px; margin-bottom: 15px"
    >
      <img src="../../../assets/icons/exitDoor.svg" alt="Sign out icon" />
      <p class="heading-xl ml-8" style="line-height: 40px">
        You have been logged out.
      </p>
    </div>
    <p
      class="heading-l"
      style="
        line-height: 24px;
        margin-bottom: 40px;
        margin-left: 7px !important;
      "
    >
      You are now logged out of the Sales Tax Database. To log in again, click
      the button<br />
      below to return to the homepage.
    </p>
    <kds-button
      kind="primary-inverse"
      class="homepage-btn text-neutral-800 body-m lh-20 roboto-medium-font"
      routerLink="/home"
      >Go to Homepage</kds-button
    >
  </div>
</div>
